import React from 'react';
import { useGetPermissions, useUser } from 'worldover/hooks';

import LandingPageDefault from './LandingPageDefault';
import { LandingPageFreeTier } from './LandingPageFreeTier/LandingPageFreeTier';
import { LandingPageLoading } from './LandingPageLoading';

export const LandingPage = () => {
  const {
    user: { firstName },
    isLoading: isLoadingUser,
  } = useUser();

  const { organisationPermissions, isLoading: isLoadingPermissions } =
    useGetPermissions();

  const isInUpsellMode = organisationPermissions?.sidebar.upgradeSection;

  if (isLoadingUser || isLoadingPermissions) {
    return <LandingPageLoading />;
  }

  if (isInUpsellMode) {
    return (
      <LandingPageFreeTier
        firstName={firstName}
        organisationPermissions={organisationPermissions}
      />
    );
  }

  return <LandingPageDefault firstName={firstName} />;
};
